import { render, staticRenderFns } from "./ui-cta-wrapper.vue?vue&type=template&id=08abeed2&"
import script from "./ui-cta-wrapper.vue?vue&type=script&lang=js&"
export * from "./ui-cta-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports